<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Slogan -->
            <d-col md="12" class="form-group">
              <label for="name">
                {{ $t('settings.messages.form.slogan.label') }}
                <span class="text-muted">{{ $t('settings.messages.form.slogan.hint') }}</span>
              </label>
              <editor
                ref="slogan"
                :model.sync="model.slogan"
                :placeholder="$t('settings.messages.form.slogan.placeholder')"
              ></editor>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Receipt Message -->
            <d-col md="12" class="form-group">
              <label>{{ $t('settings.messages.form.receipt.label') }}</label>
              <editor ref="recibo" :model.sync="model.receipt"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Guaranty Message -->
            <d-col md="12" class="form-group">
              <label>{{ $t('settings.messages.form.warranty.label') }}</label>
              <editor ref="warranty" :model.sync="model.warranty"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- approbation Message -->
            <d-col md="12" class="form-group">
              <label>{{ $t('settings.messages.form.approbation.label') }}</label>
              <editor ref="approbation" :model.sync="model.approbation"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>
                {{ $t('settings.messages.form.sendMessage.label') }}
                <span class="text-muted">{{ $t('settings.messages.form.sendMessage.hintEmail') }}</span>
              </label>
              <editor ref="send" :model.sync="model.sendMessage"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>
                {{ $t('settings.messages.form.sendMessage.label') }}
                <span class="text-muted">{{ $t('settings.messages.form.sendMessage.hintWhatsapp') }}</span>
              </label>
              <textarea class="form-control" rows="10" v-model="model.sendMessageWhats"></textarea>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Footer Message -->
            <d-col md="12" class="form-group">
              <label for="feInputFooter">{{ $t('settings.messages.form.footer.label') }}</label>
              <d-form-input type="text" id="feInputFooter" v-model="model.footer" />
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">{{ $t('shared.actions.save') }}</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
  <!-- </d-card> -->
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_MESSAGE_, MESSAGES } from './SettingsModel';

export default {
  name: 'messages-form',
  components: {
    Editor,
  },
  data() {
    return {
      model: { ...MESSAGES },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    submit() {
      this.loading = true;
      SettingsService.saveOptions(this.model, 'message')
        .then(() => {
          this.getSettings();
          this.activeAlert({
            message: this.$t('settings.alert.messagesSaved'),
            theme: 'success',
          });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_MESSAGE_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.text-muted { font-size: 12px;}
</style>
